import { PARAGUAY_CITIES } from "./geography-data.js";
export { PARAGUAY_CITIES, PARAGUAY_GEOGRAPHY_SOURCE } from "./geography-data.js";
export function normalizeCatalogText(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("es-PY").replace(/[^a-z0-9]+/g, " ").trim();
}
const citiesByCode = new Map(PARAGUAY_CITIES.map((city) => [city.code, city]));
const citiesByName = new Map();
for (const city of PARAGUAY_CITIES) {
    const key = normalizeCatalogText(city.name);
    citiesByName.set(key, [...(citiesByName.get(key) ?? []), city]);
}
export function findParaguayCity(value, cityCode) {
    if (cityCode)
        return citiesByCode.get(cityCode) ?? null;
    const name = normalizeCatalogText(value);
    if (!name)
        return null;
    const matches = citiesByName.get(name) ?? [];
    // Nunca asignar un departamento por adivinación, p. ej. Bella Vista.
    return matches.length === 1 ? matches[0] ?? null : null;
}
export function cityMatchesLocation(location, city, cityCode) {
    if (cityCode) {
        const expected = findParaguayCity("", cityCode);
        if (!expected)
            return false;
        return findParaguayCity(location.city, location.cityCode)?.code === expected.code;
    }
    return !city || normalizeCatalogText(location.city) === normalizeCatalogText(city);
}
export function locationCityLabel(location) {
    const city = findParaguayCity(location.city, location.cityCode);
    return city && city.departmentCode !== "00" ? `${location.city || city.name} · ${city.department}` : location.city || city?.name || "";
}
